import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import s from './InfoMessages.css';

class InfoMessages extends React.Component {
  static propTypes = {
    countToday: PropTypes.number,
    threshold: PropTypes.number,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    threshold: 2,
    countToday: null,
  };

  state = {
    messages: [],
  };

  componentDidUpdate(prevProps) {
    const { countToday, threshold, intl } = this.props;

    if (!prevProps.countToday && countToday && countToday > threshold) {
      this.enqueueMessage(
        intl.formatMessage(
          {
            id:
              'Сегодня это объявление было просмотрено {count} {count, plural, one {раз} few {раза} many {раз}}',
          },
          { count: countToday },
        ),
      );
    }
  }

  enqueueMessage = text => {
    const message = { text };
    this.setState(({ messages }) => ({ messages: [...messages, message] }));
  };

  render() {
    return (
      <div className={s.root}>
        <ReactCSSTransitionGroup
          transitionName="fadeUp"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={100}
        >
          {this.state.messages.map(({ text }) =>
            // eslint-disable-next-line react/no-array-index-key
            <div key={text} className={s.message}>
              {text}
            </div>,
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(InfoMessages));



// WEBPACK FOOTER //
// ./src/desktop/components/InfoMessages/InfoMessages.js